import { useContext, useEffect, useState } from "react";
import AppBanner from "../AppBanner";
import ChatBoxComponent from "src/components/organisms/coach/ChatBoxComponent";
import { MyContext } from "src/components/Context/MyContext";
import {
  findDifferentObjects,
  getMessageToken,
} from "src/services/functions/sendMessagefunction";
import moment from "moment";

const ChatContainer = () => {
  
  return (
    <>
      <div className="bg-transparent  translate-y-80 md:translate-y-0  fixed inset-0 my-4 md:pr-4 lg:pr-0 ml-4 h-[45vh] md:h-[calc(100vh-10%)] w-[92vw] md:w-[72vw]  transition-transform duration-300 md:translate-x-[26vw] mt-20 ">
        <ChatBoxComponent/>
      </div>
    </>
  );
};

export default ChatContainer;
